module.exports = __webpack_public_path__ + "static/media/send.568717b4.svg";